"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from "react";
import { useRegistry } from "~/components/registry/registry-provider";
import DefaultFooter from "./footer-eon";

/**
 * Renders the client-specific footer from the registry when provided (e.g. Grid Solutions),
 * otherwise the default E.ON footer.
 */
export default function FooterFromRegistry() {
  const $ = _c(3);
  const {
    components
  } = useRegistry();
  const RegistryFooter = (components as {
    Footer?: ComponentType;
  }).Footer;
  if (RegistryFooter) {
    let t0;
    if ($[0] !== RegistryFooter) {
      t0 = <RegistryFooter />;
      $[0] = RegistryFooter;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DefaultFooter />;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}